import React from 'react'
import VanillaTilt from 'vanilla-tilt'
import { Box } from 'rebass'

class Tiltable extends React.Component {
  constructor(props) {
    super(props)
    this.tiltRef = React.createRef()
  }

  componentDidMount() {
    VanillaTilt.init(this.tiltRef.current, {
      max: 15,
      glare: false,
    })
  }

  componentWillUnmount() {
    this.tiltRef.current.vanillaTilt.destroy()
  }

  render() {
    return (
      <Box css={{ display: 'inline-block' }} ref={this.tiltRef}>
        {this.props.children}
      </Box>
    )
  }
}

export default Tiltable
